module.exports = __webpack_public_path__ + "img/Hosting.79352c18.jpg";